import React from "react";
import PropTypes from "prop-types";
import DealerList from "../../components/DealerList";
import { Link } from "react-router-dom";
import { Row, Col } from "reactstrap";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { faEdit, faPlus, faCheck } from "@fortawesome/fontawesome-free-solid";
import WithFetchingDealers from "../WithFetchDealers/index";
import { compose, lifecycle, setDisplayName, withHandlers } from "recompose";
import { get } from "lodash";
import Button from "../../components/CustomButton";

const propTypes = {
  dealers: PropTypes.array,
  match: PropTypes.object
};

const Dealers = props => {
  const { dealers, onSelectDealer, isSelected } = props;
  return (
    <div className="content">
      <div className="row justify-content-between">
        <div className="col-auto">
          <h4 className="title">Dealers</h4>
        </div>
        <div className="col-auto">
          <h4 className="title">
            <Link to={`/dealers/new`}>
              Create Dealer <FontAwesomeIcon icon={faPlus} />
            </Link>
          </h4>
        </div>
      </div>
      <br />
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <DealerList dealers={dealers || []}>
            {({ dealer }) => (
              <div className="row align-items-center justify-content-between">
                <div className="col-6 text-center">
                  <Button
                    fill={isSelected(dealer)}
                    color={isSelected(dealer) ? "primary" : "default"}
                    onClick={onSelectDealer(dealer)}
                  >
                    Select <FontAwesomeIcon icon={faCheck} />
                  </Button>
                </div>
                <div className="col-6 text-center">
                  <Link to={`/dealers/${dealer.id}/edit`}>
                    <FontAwesomeIcon icon={faEdit} />
                  </Link>
                </div>
              </div>
            )}
          </DealerList>
        </Col>
      </Row>
    </div>
  );
};

export const withSelectDealer = lifecycle({
  componentDidMount() {
    const { setCurrentDealer, currentDealer, dealers } = this.props;
    if (!currentDealer && dealers.length === 1) {
      setCurrentDealer(dealers[0]);
    }
  }
});

Dealers.propTypes = propTypes;

export default compose(
  setDisplayName("Dealers"),
  WithFetchingDealers,
  withSelectDealer,
  withHandlers({
    onSelectDealer: ({ setCurrentDealer }) => dealer => () => {
      setCurrentDealer(dealer);
    },
    isSelected: props => dealer =>
      get(props, "currentDealer.id", "") === dealer.id
  })
)(Dealers);
